import React, { useState, useEffect, useContext } from 'react';
import './UserDetails.css';
import { useNavigate ,useParams } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import {
     Button
    ,Checkbox
    ,Dialog
    ,DialogActions
    ,DialogContent
    ,DialogTitle
    ,IconButton
    ,FormControlLabel
    ,Switch
    ,TextField
} from '@mui/material';

import {
     ArrowLeft
    ,VisibilityIcon
    ,VisibilityOffIcon
} from '../../../assets/icons/icons';

import CircleProgress  from "../../../components/CircleProgress/CircleProgress";
import PrivilegeList from './components/PrivilegeList';
import axios  from 'axios';
import { AuthContext } from '../../../contexts/authContext';
import config from '../../../config';
import configMessage from '../../../utils/configMessage.json';

function UserDetails(props) {
    const navigate = useNavigate();
    const urlParams = useParams();
    const auth = useContext(AuthContext);    

    const
         [ userId                    , setUserId                    ] = useState('')
        ,[ username                  , setUsername                  ] = useState('')
        ,[ nome                      , setNome                      ] = useState('')
        ,[ cognome                   , setCognome                   ] = useState('')
        ,[ password               /* , setPassword               */ ] = useState('')
        ,[ confirmPassword        /* , setConfirmPassword        */ ] = useState('')
        ,[ eMailAddress              , setEMailAddress              ] = useState('')
        ,[ agenteCod                 , setAgenteCod                 ] = useState('')
        ,[ forcePassword             , setForcePassword             ] = useState('')
        ,[ confirmForcePassword      , setConfirmForcePassword      ] = useState('')
 //     ,[ showPassword              , setShowPassword              ] = useState(false)
 //     ,[ showConfirmPassword       , setShowConfirmPassword       ] = useState(false)
        ,[ showForcePassword         , setShowForcePassword         ] = useState(false)
        ,[ showConfirmForcePassword  , setShowConfirmForcePassword  ] = useState(false)
        ,[ flagAdmin                 , setFlagAdmin                 ] = useState(false)
        ,[ flagAttivo                , setFlagAttivo                ] = useState(false)
        ,[ toggleEnabled             , setToggleEnabled             ] = useState(false)
        ,[ flagDoppioProfilo         , setFlagDoppioProfilo         ] = useState(false)
        ,[ admin                     , setAdmin                     ] = useState(false)
        ,[ dataUltimaLogin           , setDataUltimaLogin           ] = useState('')
        ,[ dataCancellazione         , setDataCancellazione         ] = useState('')
        ,[ dataInserimento           , setDataInserimento           ] = useState('')
        ,[ dataUltimaModifica        , setDataUltimaModifica        ] = useState('')
        ,[ refreshPrivilegesList     , setRefreshPrivilegesList     ] = useState(false)
        ,[ loading                   , setLoading                   ] = useState(true)
        ,[ openDelUser               , setOpenDelUser               ] = useState(false)
//        ,[ listaAgenteCod            , setListaAgenteCod            ] = useState([])
 //     ,[ kUser                     , setKUser                     ] = useState(urlParams.kUser)
        ,[ roles                     , setRoles                     ] = useState([])
        ,[ /* roleCod */             , setRoleCod                   ] = useState('')
 //     ,[ isModalOpen               , setIsModalOpen               ] = useState(false)
        ,[ openForcePassword         , setOpenForcePassword         ] = useState(false)
 //     ,[ linkEdit                  , setLinkEdit                  ] = useState(false)
 //     ,[ linkEditId                , setLinkEditId                ] = useState("")
 //     ,[ modalNewRole              , setModalNewRole              ] = useState(false)
        ,[ childComponentSave        , setChildComponentSave        ] = useState(false)
 //     ,[ locations                 , setLocations                 ] = useState([])
    ;

    useEffect(() => {
        loadUser();
    }, [])

    const getUserRoles = async() => {
        try{
            
            let axiosParams = {
                url: '/users/user-get-roles',
                method: 'get',
                baseURL: config.API_URL,
                headers: {Authorization: `Bearer ${await auth.getAccessTokenForBE()}`},
                params: { kUser: urlParams.kUser }
            }

            let response = await axios(axiosParams);
            const roleCodArray = response?.data?.filter(item => item.FLAG_GRANTED === 'Y').map(item => item.ROLE_COD) || [];
            
            setRoles(response?.data || []);
            setRoleCod(roleCodArray);
        }catch(error){
            NotificationManager.error(configMessage.UNEXPECTER_ERROR, "", config.TIMEOUT_MSG_ERROR_GEN);
        }
        setLoading(false);
    }

    const loadUser = async() => {
        setLoading(true);
        try{
            let axiosParams = {
                url:    '/users/user-get',
                method: 'get',
                baseURL: config.API_URL,
                headers: {Authorization: `Bearer ${await auth.getAccessTokenForBE()}`},
                params: { kUser: urlParams.kUser }
            }

            let response = await axios(axiosParams);
            let data = response.data;
            if (data != null) {
                setUserId(data.KUSER);
                setUsername(data.USERNAME);
                setNome(data.NOME);
                setCognome(data.COGNOME);
                setEMailAddress(data.EMAIL_ADDRESS);
                setAgenteCod(data.AGENTE_COD);
                setFlagAdmin(data.FLAG_ADMIN === 'Y');
                setAdmin(data.FLAG_ADMIN === 'Y');
                setFlagAttivo(data.FLAG_ATTIVO === 'Y');
                setToggleEnabled(data.FLAG_ATTIVO === 'Y');
                setFlagDoppioProfilo(data.FLAG_DOPPIO_PROFILO === 'Y');
                setDataUltimaLogin(data.DATA_ULTIMA_LOGIN);
                setDataUltimaModifica(data.DATA_ULTIMA_MODIFICA);
                setDataInserimento(data.DATA_INSERIMENTO);
                setDataCancellazione(data.DATA_CANCELLAZIONE);
            }
            getUserRoles();
        }catch(error){
            NotificationManager.error(configMessage.UNEXPECTER_ERROR, "", config.TIMEOUT_MSG_ERROR_GEN);
        }
        setLoading(false);
    }

    const handleChange = (event) => {
        let field = event.target.name;
        let value = event.target.value;

        switch (field) {
            case 'username':
                setUsername(value)
                break;
            case 'cognome':
                setCognome(value)
                break;
            case 'nome':
                setNome(value)
                break;
            case 'eMailAddress':
                setEMailAddress(value)
                break;
            case 'agenteCod':
                setAgenteCod(value)
                break;
            case 'forcePassword':
                setForcePassword(value)
                break;
            case 'confirmForcePassword':
                setConfirmForcePassword(value)
                break;
            default:
                break;
        }
    }

    const handleSubmitRoles = () => {
        getUserRoles();
    }
    
    const setComponentSaveFalse = () => {
        setChildComponentSave(false);
    }

    const handleSubmit = async(event) => {
        try{
            if (admin !== true || admin !== flagAdmin) {
                setChildComponentSave(true);
            } else {
                setChildComponentSave(false);
            }
            let grantedRoles = []
            for (let i = 0; i < roles.length; i++) {
                if(roles[i]['FLAG_GRANTED']==='Y'){
                    grantedRoles.push(roles[i]['ROLE_COD']);
                }
            }
            const roleCodesList = grantedRoles.join();

            /*
            let AgentCods = '';
            if(listaAgenteCod){
                AgentCods = listaAgenteCod.split(',');
                
                for (let index = 0; index < AgentCods.length; index++) {
                    
                    let element = AgentCods[index].trim();

                    if(!element || element.length > 5 || element.includes(' ')){
                        throw new Error('Agent Cod. is not in compliance')
                    }

                    AgentCods[index] = element;
                }
                AgentCods = AgentCods.join(', ');
            }
            */

            const params = {
                userId,
                username,
                nome,
                password,
                confirmPassword,
                cognome,
                eMailAddress,
                pRoleCodesList: roleCodesList,
                flagAdmin: flagAdmin === true ? 'Y' : 'N',
                flagAttivo: flagAttivo === true ? 'Y' : 'N',
                flagDoppioProfilo: flagDoppioProfilo === true ? 'Y' : 'N',
                agenteCod,
            };

            if (toggleEnabled !== flagAttivo) {
                if(flagAttivo){
                    await enableUser();
                }else{
                    await disableUser();
                }
            }

            await submitMod(event, params);

        }catch (error){
            if(error?.response?.data?.message === "Agent Cod. is not in compliance"){
                NotificationManager.error(error?.response?.data?.message || configMessage.UNEXPECTER_ERROR, "", config.TIMEOUT_MSG_ERROR_GEN);
            }else{
                NotificationManager.error(configMessage.USER_ERROR, "", config.TIMEOUT_MSG_ERROR_GEN);
            }
        }
        loadUser();
        createUserRoleList();
    }

    const changeGranted = (roleIndex) => {
        let rolesToSet = [...roles];
        const grantedValue = rolesToSet[roleIndex]['FLAG_GRANTED'];

        if(grantedValue === "Y"){
            rolesToSet[roleIndex]['FLAG_GRANTED'] = 'N';
        }else{
            rolesToSet[roleIndex]['FLAG_GRANTED'] = 'Y';
        }

        setRoles(rolesToSet);
    }

    const createUserRoleList = () => {
        const rolesList = roles;
        let htmlList = [];

        for (let i = 0; i < rolesList.length; i++) {
            const roleDesc = rolesList[i]["ROLE_DESC"];
            const isGranted = rolesList[i]["FLAG_GRANTED"] === 'Y';

            if(isGranted) {
                htmlList.push(
                    <FormControlLabel
                        key={i}
                        control={
                          <Checkbox
                            color="primary"
                            checked={!admin}
                            onChange={() => changeGranted(i)}
                            disabled={admin}
                            
                          />
                        }
                    label={roleDesc}
                  />
                );
            }else{
                htmlList.push(
                    <FormControlLabel
                        key={i}
                        control={
                          <Checkbox
                            color="default"
                            checked={false}
                            onChange={() => changeGranted(i)}
                            disabled={admin}
                            
                          />
                        }
                    label={roleDesc}
                  />
                );
            }
        }
        
        return htmlList;
    }

    const submitMod = async(event, params) => {
        //console.log(params);
        
        try {
            let axiosParams = {
				url: '/users/user-mod',
				method: 'post',
                baseURL: config.API_URL,
                headers: {Authorization: `Bearer ${await auth.getAccessTokenForBE()}`},                
				params: {
					...params
				},
                handleError: true
			}

			const response = await axios(axiosParams);

            const responseRetVal = response?.data || 0;

            if(responseRetVal <= 0){
                let errorMessage = "";
                switch (responseRetVal) {
                    case -2:
                        errorMessage = "Insufficient privileges to perform the operation";
                        break;
                    case -3:
                        errorMessage = "Username required";
                        break;
                    case -4:
                        errorMessage = "Surname required";
                        break;
                    case -5:
                        errorMessage = "Username already exists, or is longer than 50 characters";
                        break;
                    case -6:
                        errorMessage = "Username does not exist";
                        break;
                    case -7:
                        errorMessage = "E-mail already exists, or is longer than 254 characters";
                        break;
                    default:
                        errorMessage = "Oops, an error has occurred";
                        break;
                }

                NotificationManager.error(errorMessage, "", config.TIMEOUT_MSG_ERROR_GEN);
                setLoading(false);
                return;
            }

            setAdmin(flagAdmin)

            if (admin !== true) {
                setChildComponentSave(true);
            } else {
                setChildComponentSave(false);
            }

            handleSubmitRoles();

            setChildComponentSave(false);
            
            NotificationManager.success(configMessage.USER_SUCCESS, "", config.TIMEOUT_MSG_SUCCESS);

        } catch (error) {
            console.error(error);
            NotificationManager.error(configMessage.UNEXPECTER_ERROR, "", config.TIMEOUT_MSG_ERROR_GEN);
        }
        setLoading(false);
    }

    const formatDate = (dbDate) => {
        if (dbDate == null) {
            return '';
        }

        dbDate = dbDate.trim();

        if(dbDate === '' || (dbDate.length !== 8 && dbDate.length !== 14)){
            return '';
        }

        let Y = dbDate.substring(0,4);
        let M = dbDate.substring(4,6);
        let D = dbDate.substring(6,8);

        return D + "/" + M + "/" + Y;
    }

    const formatTime = (dbDate) => {
        if(dbDate==null){
            return '';
        }
        let h = dbDate.substring(8,10);
        let m = dbDate.substring(10,12);
        let s = dbDate.substring(12,14);

        return h + ":" + m + ":" + s;
    }


    const formatDateTime = (dbDate) => {
        if (dbDate === null)
            return "";

        return formatDate(dbDate) + " " + formatTime(dbDate);
    }

    const deleteUser = async() => {
        try {
            let axiosParams = {
				url: '/users/user-del',
				method: 'post',
				params: { userId },
                baseURL: config.API_URL,
                headers: {Authorization: `Bearer ${await auth.getAccessTokenForBE()}`},                
                handleError: true
			}
			//PNUSCG cambiare params in data
			const response = await axios(axiosParams);

            const responseRetVal = response?.data || 0;

            if(responseRetVal <= 0){
                let errorMessage = "";
                switch (responseRetVal) {
                    case -2:
                        errorMessage = "Insufficient privileges to perform the operation";
                        break;
                    case -3:
                        errorMessage = "An Administrator cannot disable himself";
                        break;
                    case -4:
                        errorMessage = "User doesn't exist or is already disabled";
                        break;
                    default:
                        errorMessage = "Oops, an error has occurred";
                    break;
                }

                NotificationManager.error(errorMessage, "", config.TIMEOUT_MSG_ERROR_GEN);
                return;
            }

            NotificationManager.success(configMessage.USER_DELETED, "", config.TIMEOUT_MSG_SUCCESS);
            navigate('/users/list');
        } catch (error) {
            NotificationManager.error(configMessage.UNEXPECTER_ERROR, "", config.TIMEOUT_MSG_ERROR_GEN);
        }
    }

    const enableUser = async () => {

        try {
            let axiosParams = {
                url: '/users/user-enable',
                method: 'post',
                baseURL: config.API_URL,
                headers: {Authorization: `Bearer ${await auth.getAccessTokenForBE()}`},                
                params: { userId: urlParams.kUser },
                handleError: true
            }

            const response = await axios(axiosParams);
        
            const responseRetVal = response?.data || 0;
          
            if(responseRetVal <= 0) {
                let errorMessage = "";
                switch (responseRetVal) {
                    case -2:
                        errorMessage = configMessage.NO_PRIVILEGES_ERROR;
                        break;
                    case -3:
                        errorMessage = configMessage.NO_EXIST_ENABLE_ERR;
                        break;
                    default:
                        errorMessage = configMessage.UNEXPECTER_ERROR;
                        break;
                }

                NotificationManager.error(errorMessage, "", config.TIMEOUT_MSG_ERROR_GEN);
                return;
            }
        } catch (error) {
          console.error(error);
          NotificationManager.error(configMessage.UNEXPECTER_ERROR, "", config.TIMEOUT_MSG_ERROR_GEN);
        }
    }

    const disableUser = async () => {
        try {
            let axiosParams = {
				url: '/users/user-disable',
				method: 'post',
                baseURL: config.API_URL,
                headers: {Authorization: `Bearer ${await auth.getAccessTokenForBE()}`},                
				params: { userId: urlParams.kUser },
                handleError: true
			}
				//PNUSCG cambiare params in data
			const response = await axios(axiosParams);
        
            const responseRetVal = response?.data || 0;
    
            if(responseRetVal <= 0) {
                let errorMessage = "";
                switch (responseRetVal) {
                    case -2:
                        errorMessage = configMessage.NO_PRIVILEGES_ERROR;
                        break;
                    case -3:
                        errorMessage = configMessage.DISABLE_THEMSELVES_ERR;
                        break;
                    case -4:
                        errorMessage = configMessage.NO_EXIST_DISABLE_ERR;
                        break;
                    default:
                        errorMessage = configMessage.UNEXPECTER_ERROR;
                        break;
                }
                NotificationManager.error(errorMessage, "", config.TIMEOUT_MSG_ERROR_GEN);
                return;
            }
        } catch (error) {
            NotificationManager.error(configMessage.UNEXPECTER_ERROR, "", config.TIMEOUT_MSG_ERROR_GEN);
        }
    }

    const handleOpenForcePasswordDialog = () => {
        setOpenForcePassword(true);
    }

    const handleCloseForcePasswordDialog = () => {
        setOpenForcePassword(false);
        setForcePassword("");
        setConfirmForcePassword("");
        setShowForcePassword(false);
        setShowConfirmForcePassword(false);
    }
    
    //check Password
    const isErrorForcePassword = () => {
        let retVal = false
        let forcePasswordTrim = forcePassword.trim();

        if(forcePasswordTrim !== ""){
            if(forcePasswordTrim.length < 8 || forcePasswordTrim.length > 50){
                retVal = true;
            }
        }
        return retVal;
    }

    const isErrorConfirmForcePassword = () => {
        let retVal = false
        let forcePasswordTrim = forcePassword.trim();
        let confirmForcePasswordTrim = confirmForcePassword.trim();

        if(confirmForcePasswordTrim!== ""){
            if(confirmForcePasswordTrim !== forcePasswordTrim){
                retVal = true;
            }
        }
        return retVal;
    }

    const isDisabledButtonForcePassword = () => {
        let forcePasswordTrim = forcePassword.trim();
        let confirmForcePasswordTrim = confirmForcePassword.trim();

        return !(forcePasswordTrim.length >= 8 && forcePasswordTrim.length <= 50 && confirmForcePasswordTrim === forcePasswordTrim);
    }

    const handleForcePassword = async() => {
        setLoading(true);
        const params = {
            kUser: userId,
            newPassword: forcePassword,
        };
        try {
            let axiosParams = {
				url: '/users/user-force-password',
				method: 'post',
                baseURL: config.API_URL,
                headers: {Authorization: `Bearer ${await auth.getAccessTokenForBE()}`},                
				params,
                handleError: true
			}
				//PNUSCG cambiare params in data
			const response = await axios(axiosParams);

            const responseRetVal = response?.data || 0;

            if(responseRetVal <= 0){
                let errorMessage = "";
                switch (responseRetVal) {
                    case -3:
                        errorMessage = "Password length must range from 8 to 50 characters";
                        break;
                    case -4:
                        errorMessage = "User does not exist";
                        break;
                    case -24:
                        errorMessage = "Insufficient privileges to perform the operation";
                        break;
                    default:
                        errorMessage = "Oops, an error has occurred";
                        break;
                }

                NotificationManager.error(errorMessage, "", config.TIMEOUT_MSG_ERROR_GEN);
                setLoading(false);
                return;
            }

            handleCloseForcePasswordDialog();
            NotificationManager.success(configMessage.USER_PASSWORD, "", config.TIMEOUT_MSG_SUCCESS);
        } catch (error) {
            console.error(error)
            NotificationManager.error(configMessage.UNEXPECTER_ERROR, "", config.TIMEOUT_MSG_ERROR_GEN);
            return;
        }
        
        setLoading(false);
    }

    const handleOpenDelUserDialog = () => {
        setOpenDelUser(true);
    }

    const handleCloseDelUserDialog = () => {
        setOpenDelUser(false);
    }

    const handleChangeFlagAdmin = () => {
        setFlagAdmin(!flagAdmin);
    }

    const handleChangeFlagAttivo = () => {
        setFlagAttivo(!flagAttivo);
        // setToggleEnabled(true);
    }

    const handleChangeFlagDoppioProfilo = () => {
        setFlagDoppioProfilo(!flagDoppioProfilo);
    }

    const isDisabledButtonSubmit = () => {
        let retVal = false;

        return retVal;
    }

    //link
    // if (this.state.linkEdit === true) {
    //     const linkEditAccount = `/app/settings/users/account-details/${this.state.linkEditId}`;
    //     return <Redirect to={linkEditAccount} push={true} />
    // }

    return (
        <div className='component-container home'>
			<div className='component-card'>        
                <div className="account-detail">
                    { loading && <CircleProgress /> }
                    <div className="tools-row">
                        <div>&nbsp;</div>
                        <div className="buttons-total-save">
                                <Button variant="contained" color="primary" onClick={handleSubmit} disabled={isDisabledButtonSubmit()}>Save user</Button>
                                {/*
                                <span className="button btn-force-psw">
                                    <Button variant="contained" color="primary" onClick={handleOpenForcePasswordDialog} disabled={true}>Force Password</Button>
                                </span>
                                */}
                                <span className="button DeleteUser">
                                    <Button variant="contained" color="error"   onClick={handleOpenDelUserDialog}>Delete User</Button>
                                </span>
                        </div>
                    </div>
                    <div className="container-cards">
                        <div className="leftCard">
                            <div className="HeadTitle">
                                <div className="account-detail-main-title">User Details</div>
                            </div>
                                
                            <input type="hidden" name="userId" value={userId}/>

                            <div className="main-infos-block">
                                <div className="main-infos-row">
                                    <TextField
                                        label="Username"
                                        name="username"
                                        value={username}
                                        onChange={(event) => {handleChange(event)}}
                                        variant="standard"
                                    />
                                    <TextField
                                        label="Surname"
                                        name="cognome"
                                        value={cognome}
                                        onChange={(event) => handleChange(event)}
                                        variant="standard"
                                    />
                                </div>
                                <div className="main-infos-row">
                                    <TextField
                                        label="Name"
                                        name="nome"
                                        value={nome}
                                        onChange={(event) => handleChange(event)}
                                        variant="standard"
                                    />
                                    
                                    <TextField
                                        label="E-mail address"
                                        name="eMailAddress"
                                        value={eMailAddress}
                                        onChange={(event) => handleChange(event)}
                                        variant="standard"
                                    />

                                    <div className="main-infos-row">
                                        <TextField
                                            label="Sales Rep. Code"
                                            name="agenteCod"
                                            value={agenteCod}
                                            onChange={(event) => handleChange(event)}
                                            variant="standard"
                                        />
                                    </div>

                                </div>
                            </div>

                            <div className="flags-and-logs">
                                <div className="badges">
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                name="flagAdmin"
                                                checked={flagAdmin}
                                                onChange={handleChangeFlagAdmin}
                                                color="primary"
                                            />
                                        }
                                        label="Administrator"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                name="flagAttivo"
                                                checked={flagAttivo}
                                                onChange={handleChangeFlagAttivo}
                                                color="primary"
                                            />
                                        }
                                        label="Enabled"
                                    />
                                </div>
                                <div className="history">
                                    <div className="account-history-main-title">User history</div>
                                    <table className="padding-history">
                                        <tbody>
                                        {dataCancellazione && <tr><td className="user-disabled"><strong>Disabled on:</strong></td><td>{formatDateTime(dataCancellazione)}</td></tr>}
                                        <tr><td><strong>Created on:</strong></td><td>{formatDateTime(dataInserimento)}</td></tr>
                                        <tr><td><strong>Last login on:</strong></td><td>{formatDateTime(dataUltimaLogin)}</td></tr>
                                        <tr><td><strong>Updated on:</strong></td><td>{formatDateTime(dataUltimaModifica)}</td></tr>
                                        </tbody>
                                    </table>
                                    {/* <div className="padding-history">
                                            {dataCancellazione&&(<div className="user-disabled"><strong>Disabled on:</strong>{formatDateTime(dataCancellazione)}</div>)}
                                            <div><strong>Created on:</strong>   {formatDateTime(dataInserimento)}</div>
                                            <div><strong>Last login on:</strong>{formatDateTime(dataUltimaLogin)}</div>
                                            <div><strong>Updated on:</strong>   {formatDateTime(dataUltimaModifica)}</div>
                                        </div> 
                                    */}
                                </div>
                            </div>
                            { !admin &&  <div className="user-role-list" >
                                <div className="account-history-main-title">Roles:</div>
                                <div className="role-list-wrapper">
                                    {createUserRoleList() }
                                </div>                            
                            </div>
                            }
                        </div>

                        <div className="rightCard">
                            { !admin && <PrivilegeList kUser={urlParams.kUser} admin={admin} save={childComponentSave} setSaveFalse={setComponentSaveFalse}/> }
                        </div>
                    </div>
                        <Dialog open={openForcePassword} onClose={handleCloseForcePasswordDialog} className="modal-delete-confirm modal-password-force">
                            <DialogTitle>Force Password</DialogTitle>
                            <DialogContent>
                                <div className="row legend">
                                    <span>(Password length must range from 8 to 50 characters)</span>
                                </div>
                                <div className="passwords-field">
                                    <TextField
                                        label="New Password"
                                        variant="standard"
                                        autoComplete="off"
                                        type={showForcePassword ? "text" : "password"}
                                        name="forcePassword"
                                        value={forcePassword}
                                        onChange={(event) => handleChange(event)}
                                        error={isErrorForcePassword()}
                                        InputProps={{
                                            endAdornment:
                                                <IconButton
                                                    onClick={() => setShowForcePassword(!showForcePassword)}
                                                >
                                                    {showForcePassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                                </IconButton>
                                        }}
                                    />
                                    <TextField
                                        label="Confirm New Password"
                                        variant="standard"
                                        autoComplete="off"
                                        type={showConfirmForcePassword ? "text" : "password"}
                                        name="confirmForcePassword"
                                        value={confirmForcePassword}
                                        onChange={(event) => handleChange(event)}
                                        error={isErrorConfirmForcePassword()}
                                        InputProps={{
                                            endAdornment:
                                                <IconButton
                                                    onClick={() => setShowConfirmForcePassword(!showConfirmForcePassword)}
                                                >
                                                    {showConfirmForcePassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                                </IconButton>
                                        }}
                                    />
                                </div>
                            </DialogContent>
                            <DialogActions>
                                <Button variant="contained" color="primary" onClick={handleForcePassword} disabled={isDisabledButtonForcePassword()} >Force Password</Button>
                                <Button variant="outlined"/*variant="contained"*/ onClick={handleCloseForcePasswordDialog} autoFocus>Cancel</Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog open={openDelUser} onClose={handleCloseDelUserDialog} >
                            <DialogTitle>Delete User</DialogTitle>
                            <DialogContent>
                                Do you want to delete the selected User?<br />
                            </DialogContent>
                            <DialogActions>
                                <Button variant="contained" color="error" onClick={deleteUser}>Delete</Button>
                                <Button variant="outlined" onClick={handleCloseDelUserDialog} autoFocus>Cancel</Button>
                            </DialogActions>
                        </Dialog>
                </div>
            </div>
        </div>
    );
}

export default UserDetails;
